export { configPMH, configPMHExtra } from "../../../constants/pmh";

export const updateArrJson = ({ newData, idxChild, idxParent, jsonTree }) => {
  return jsonTree
    .map((i, idx) =>
      idx === idxParent
        ? {
            ...i,
            items: i.items
              .map((y, ydx) => (ydx === idxChild ? newData : y))
              .filter((i) => i),
          }
        : i,
    )
    .filter((i) => i.items?.length);
};

export const checkIsVitalRequired = (data) => {
  const dataLength = data.data.length;
  const emptyLength = data.data.filter((i) => !i.data).length;
  const filledLength = data.data.filter((i) => i.data).length;
  return (
    data.noMandatory &&
    emptyLength !== dataLength &&
    filledLength !== dataLength
  );
};

export const assessmentsPlanKeys = {
  medications: "medications",
  diagnosis: "diagnosis",
  textAreaAssessmentPlan: "txtAssessmentPlan",
  txtFirstPart: "txtFirstPart",
  assessments_plan: "assessments_plan",
};
